import React from 'react';
import Checkbox from '@mui/material/Checkbox';

class OrganizationCheckbox extends React.Component {
    state = {
        [this.props.orgId] : false
    };

    handleChange = name => event => {
        this.setState({ [name]: event.target.checked });
        this.props.setValues(name, event.target.checked)
    };

    render() {

        const {orgId, selectedOrganizations} = this.props;

        return (
            <div>
                <Checkbox
                    checked={selectedOrganizations.includes(orgId)} //check if data contains in array then mark as checked
                    onChange={this.handleChange(orgId)}
                    sx={{
                        color: "#aeaeae",
                        '&.Mui-checked': {
                            color: "#003300",
                        },
                    }}
                />
            </div>
        );
    }
}

export { OrganizationCheckbox };